/**
 * Reports a GA4 page_view on every client-side route change.
 * Must be rendered inside the router.
 *
 * Also re-runs when consent changes: the first view happens while the consent
 * banner is still up and is dropped, so accepting has to report the page the
 * user is actually on.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from './useCookieConsent';
import { trackPageView } from '../utils/analytics';

export const usePageTracking = (): void => {
  const { pathname } = useLocation();
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (consent !== 'granted') {
      return;
    }
    void trackPageView(pathname);
  }, [pathname, consent]);
};

export default usePageTracking;
